module.exports = __webpack_public_path__ + "static/rl_survey-ec519bc61f68947155b10fdaf3f2e671.png";